import { render, staticRenderFns } from "./TaskStatus.vue?vue&type=template&id=2ac531f3&scoped=true&"
import script from "./TaskStatus.vue?vue&type=script&lang=js&"
export * from "./TaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac531f3",
  null
  
)

export default component.exports